module.exports = __webpack_public_path__ + "static/media/apple-podcast.5fb4a6b2.svg";